// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"vr_a bhc_b"};